/* eslint-disable import/no-default-export */
export default {
  'AgenticDuoChat.chatCancelLabel': 'Cancel',
  'AgenticDuoChat.chatDefaultPredefinedPromptsChangePassword':
    'How do I change my password in GitLab?',
  'AgenticDuoChat.chatDefaultPredefinedPromptsCloneRepository': 'How do I clone a repository?',
  'AgenticDuoChat.chatDefaultPredefinedPromptsCreateTemplate': 'How do I create a template?',
  'AgenticDuoChat.chatDefaultPredefinedPromptsForkProject': 'How do I fork a project?',
  'AgenticDuoChat.chatDefaultTitle': 'GitLab Duo Agentic Chat',
  'AgenticDuoChat.chatDisclamer':
    'Chat can autonomously change code. Responses and changes can be inaccurate. Review carefully.',
  'AgenticDuoChat.chatEmptyStateTitle':
    '👋 I am GitLab Duo Agentic Chat, your personal AI-powered assistant. How can I help you today?',
  'AgenticDuoChat.chatHistoryTitle': 'Chat history',
  'AgenticDuoChat.chatPromptPlaceholderDefault': 'GitLab Duo Agentic Chat',
  'AgenticDuoChat.chatPromptPlaceholderWithCommands': 'Type /help to learn more',
  'AgenticDuoChat.chatSubmitLabel': 'Send chat message.',
  'AgenticDuoChat.overLimitCharacterCountMessage': null,
  'AgenticDuoChat.remainingCharacterCountMessage': null,
  'AgenticToolApprovalFlow.defaultDescription':
    'GitLab Duo Agentic Chat wants to execute a tool. Do you want to proceed?',
  'AgenticToolApprovalModal.approveAllText': 'Always approve this tool',
  'AgenticToolApprovalModal.approveOnceText': 'Approve Once',
  'AgenticToolApprovalModal.approveText': 'Approve',
  'AgenticToolApprovalModal.defaultDescription':
    'GitLab Duo Agentic Chat wants to execute a tool. Do you want to proceed?',
  'AgenticToolApprovalModal.denyText': 'Deny',
  'AgenticToolApprovalModal.title': 'Tool Approval Required',
  'AgenticToolApprovalModal.toolLabel': 'Tool:',
  'AgenticToolApprovalModal.toolUnknown': 'Unknown',
  'AgenticToolRejectionModal.backText': 'Back',
  'AgenticToolRejectionModal.description':
    'You are about to reject the tool execution. Would you like to provide a reason?',
  'AgenticToolRejectionModal.label': 'Rejection reason',
  'AgenticToolRejectionModal.placeholder': "Explain why you're rejecting this tool execution...",
  'AgenticToolRejectionModal.submitText': 'Submit Rejection',
  'AgenticToolRejectionModal.title': 'Provide Rejection Reason',
  'BaseToolParams.ACCORDION_TITLE': 'Read description',
  'CreateCommitToolParams.actionWithNoContent': 'This action does not have any content.',
  'CreateCommitToolParams.actionsCountMessage': null,
  'CreateCommitToolParams.chmodFileActionLabel': 'Change permissions for file %{filePath}',
  'CreateCommitToolParams.commitSummaryAutoBranchMessage':
    'Create a commit in a new auto-created branch and project %{project}.',
  'CreateCommitToolParams.commitSummaryMessage':
    'Create a commit in the branch %{branch} and project %{project}.',
  'CreateCommitToolParams.createFileActionLabel': 'Create file %{filePath}',
  'CreateCommitToolParams.deleteFileActionLabel': 'Delete file %{filePath}',
  'CreateCommitToolParams.expandFileChanges': 'Expand file changes',
  'CreateCommitToolParams.moveFileActionLabel': 'Move file %{filePath}',
  'CreateCommitToolParams.noActionsMessage': 'The commit does not contain changes.',
  'CreateCommitToolParams.readCommitMessage': 'Read commit message',
  'CreateCommitToolParams.unknownFileActionLabel': 'Modify file %{filePath}',
  'CreateCommitToolParams.updateFileActionLabel': 'Update file %{filePath}',
  'DuoChat.chatBackLabel': 'Back to history',
  'DuoChat.chatBackToChatToolTip': 'Back to chat',
  'DuoChat.chatCancelLabel': 'Cancel',
  'DuoChat.chatDefaultPredefinedPromptsChangePassword': 'How do I change my password in GitLab?',
  'DuoChat.chatDefaultPredefinedPromptsCloneRepository': 'How do I clone a repository?',
  'DuoChat.chatDefaultPredefinedPromptsCreateTemplate': 'How do I create a template?',
  'DuoChat.chatDefaultPredefinedPromptsForkProject': 'How do I fork a project?',
  'DuoChat.chatDefaultTitle': 'GitLab Duo Chat',
  'DuoChat.chatDropdownMoreOptions': 'More options',
  'DuoChat.chatEmptyStateTitle':
    '👋 I am GitLab Duo Chat, your personal AI-powered assistant. How can I help you today?',
  'DuoChat.chatHistoryInfo': 'Inactive chats are deleted after 30 days.',
  'DuoChat.chatHistoryToolTip': 'Chat history',
  'DuoChat.chatNewLabel': 'New chat',
  'DuoChat.chatNewToolTip': 'New chat',
  'DuoChat.chatPromptPlaceholderDefault': 'GitLab Duo Chat',
  'DuoChat.chatPromptPlaceholderWithCommands': 'Type /help to learn more',
  'DuoChat.chatSubmitLabel': 'Send chat message.',
  'DuoChat.chatTitle': 'GitLab Duo Chat',
  'DuoChat.closeChatHeaderLabel': 'Close chat',
  'DuoChat.copySessionIdFailedToast': 'Could not copy session ID',
  'DuoChat.copySessionIdSuccessToast': 'Session ID copied to clipboard',
  'DuoChat.copySessionIdTooltip': 'Copy session ID: %{id}',
  'DuoChat.emptyHistoryAlt':
    'Clock icon with circular arrow, indicating chat history or time-based functionality',
  'DuoChat.emptyHistoryCopy': 'Your previous chats will appear here.',
  'DuoChat.emptyHistoryTitle': 'See your chat history',
  'DuoChat.openChatLabel': 'Open chat: %{title}',
  'DuoChat.threadDeleteLabel': 'Delete this chat',
  'DuoChat.verifiedAgent': 'Created and maintained by GitLab',
  'DuoChatContextItemDetailsModal.contentErrorMessage': 'Item content could not be displayed.',
  'DuoChatContextItemDetailsModal.title': 'Preview',
  'DuoChatContextItemMenu.emptyStateMessage': 'No results found',
  'DuoChatContextItemMenu.loadingMessage': 'Loading...',
  'DuoChatContextItemMenu.searchInputPlaceholder': 'Search %{categoryLabel}...',
  'DuoChatContextItemMenu.selectedContextItemsTitle': 'Included references',
  'DuoChatContextItemPopover.DisabledReason': 'This item is disabled',
  'DuoChatConversation.newChat': 'New chat',
  'DuoChatLoader.gitlabDuo': 'GitLab Duo',
  'DuoChatLoader.loaderLoadingMessage': '%{tool} is %{transition} an answer',
  'DuoChatLoader.loaderLoadingTransitionsFinding': 'finding',
  'DuoChatLoader.loaderLoadingTransitionsGenerating': 'generating',
  'DuoChatLoader.loaderLoadingTransitionsProducing': 'producing',
  'DuoChatLoader.loaderLoadingTransitionsWorkingOn': 'working on',
  'DuoChatMessage.SelectedContextItemsTitleAssistantMessage': null,
  'DuoChatMessage.SelectedContextItemsTitleUserMessage': null,
  'DuoChatMessage.actionLabel': 'Action',
  'DuoChatMessage.branchLabel': 'Branch',
  'DuoChatMessage.chatMessageCopied': 'Copied',
  'DuoChatMessage.chatMessageCopyToClipboard': 'Copy to clipboard',
  'DuoChatMessage.commitMessageLabel': 'Commit message',
  'DuoChatMessage.contentLabel': 'Content',
  'DuoChatMessage.filePathLabel': 'File path',
  'DuoChatMessage.fromDuo': 'Duo:',
  'DuoChatMessage.fromMe': 'Me:',
  'DuoChatMessage.modalAlertText':
    'GitLab team members cannot view your conversation. Please be as descriptive as possible.',
  'DuoChatMessage.modalBetterResponse': 'How the response might better meet your needs.',
  'DuoChatMessage.modalDidWhat': 'What were you doing?',
  'DuoChatMessage.modalImproveWhat': 'How could the response be improved?',
  'DuoChatMessage.modalInteraction': 'The situation in which you interacted with GitLab Duo Chat.',
  'DuoChatMessage.modalMessageError': 'Error sending the message',
  'DuoChatMessage.modalTitle': 'Give feedback on GitLab Duo Chat',
  'DuoChatMessage.projectLabel': 'Project',
  'DuoChatMessage.ranTerminalCommand': 'Ran terminal command',
  'DuoChatMessage.startBranchLabel': 'Start branch',
  'DuoChatMessageSources.messageSources': null,
  'DuoRecentCollapsable.viewAllText': 'View All',
  'GlDuoChat.chatDisclamer': 'Responses may be inaccurate. Verify before use.',
  'GlDuoChat.chatHistoryTitle': 'Chat history',
  'IssuableToolParams.ASSIGN_LABELS_MESSAGE': 'Assign the labels <code>%{labels}</code>.',
  'IssuableToolParams.BRANCH_MESSAGE':
    'From branch <code>%{sourceBranch}</code> to branch <code>%{targetBranch}</code>.',
  'IssuableToolParams.CONFIDENTIAL_MESSAGE': 'Set as confidential.',
  'IssuableToolParams.CREATE_EPIC': 'Create an epic in group <code>%{groupId}</code>.',
  'IssuableToolParams.CREATE_ISSUE': 'Open an issue in project <code>%{project}</code>.',
  'IssuableToolParams.CREATE_MERGE_REQUEST':
    'Open a merge request in project <code>%{project}</code>.',
  'IssuableToolParams.CREATE_WORK_ITEM':
    'Create a work item with type <em>"%{typeName}"</em> in %{workItemParentType} <code>%{workItemParentId}</code>.',
  'IssuableToolParams.ISSUE_LABEL': 'issue',
  'IssuableToolParams.MERGE_REQUEST_LABEL': 'merge request',
  'IssuableToolParams.NOTE_ACCORDION_TITLE': "Read note's content",
  'IssuableToolParams.NOTE_MESSAGE':
    'Post a note on %{noteParentLabel} <code>%{noteParentIid}</code>.',
  'IssuableToolParams.TITLE_MESSAGE': 'Set the title "<em>%{title}</em>".',
  'IssuableToolParams.UPDATE_EPIC':
    'Update epic <code>%{epicId}</code> in group <code>%{groupId}</code>.',
  'IssuableToolParams.UPDATE_ISSUE':
    'Update issue <code>%{issueIid}</code> in project <code>%{project}</code>.',
  'IssuableToolParams.UPDATE_MERGE_REQUEST':
    'Update merge request <code>%{mergeRequestIid}</code> in project <code>%{project}</code>.',
  'IssuableToolParams.UPDATE_WORK_ITEM':
    'Update work item <code>%{workItemIid}</code> in %{workItemParentType} <code>%{workItemParentId}</code>.',
  'IssuableToolParams.WORK_ITEM_LABEL': 'work item',
  'MessageToolApproval.approveAllText': 'Always approve this tool',
  'MessageToolApproval.approveSessionText': 'Approve for session',
  'MessageToolApproval.approveText': 'Approve',
  'MessageToolApproval.approvingText': 'Approving...',
  'MessageToolApproval.cancelText': 'Cancel',
  'MessageToolApproval.collapseButtonCollapsed': 'Display tool details',
  'MessageToolApproval.collapseButtonExpanded': 'Hide tool details',
  'MessageToolApproval.createCommit': 'Duo wants to push a commit.',
  'MessageToolApproval.createEpic': 'Duo wants to create an epic.',
  'MessageToolApproval.createIssue': 'Duo wants to open an issue.',
  'MessageToolApproval.createIssueNote': 'Duo wants to post a note on an issue.',
  'MessageToolApproval.createMergeRequest': 'Duo wants to create a merge request.',
  'MessageToolApproval.createMergeRequestNote': 'Duo wants to post a note on a merge request.',
  'MessageToolApproval.createWorkItem': 'Duo wants to create a work item.',
  'MessageToolApproval.createWorkItemNote': 'Duo wants to post a note on a work item.',
  'MessageToolApproval.denialReasonLabel': 'Rejection reason',
  'MessageToolApproval.denialReasonPlaceholder':
    "Tell Duo why you're rejecting this tool execution...",
  'MessageToolApproval.denyText': 'Deny',
  'MessageToolApproval.denyingText': 'Denying...',
  'MessageToolApproval.noParametersText': 'No parameters will be sent with this request.',
  'MessageToolApproval.parametersText': 'Request parameters',
  'MessageToolApproval.runCommand': 'Duo wants to run a command.',
  'MessageToolApproval.runGitCommand': 'Duo wants to run a git command.',
  'MessageToolApproval.toolApprovalDescription':
    'GitLab Duo Agentic Chat wants to execute a tool. Do you want to proceed?',
  'MessageToolApproval.toolLabel': 'Tool:',
  'MessageToolApproval.toolStatusApproved': 'Approved',
  'MessageToolApproval.toolStatusPending': 'Pending',
  'MessageToolApproval.toolUnknown': 'Unknown',
  'MessageToolApproval.updateEpic': 'Duo wants to update an epic.',
  'MessageToolApproval.updateIssue': 'Duo wants to update an issue.',
  'MessageToolApproval.updateWorkItem': 'Duo wants to update a work item.',
  'RunCommandToolParams.ACCORDION_TITLE': 'Expand command output',
  'WebAgenticDuoChat.chatCancelLabel': 'Cancel',
  'WebAgenticDuoChat.chatDefaultPredefinedPromptsChangePassword':
    'How do I change my password in GitLab?',
  'WebAgenticDuoChat.chatDefaultPredefinedPromptsCloneRepository': 'How do I clone a repository?',
  'WebAgenticDuoChat.chatDefaultPredefinedPromptsCreateTemplate': 'How do I create a template?',
  'WebAgenticDuoChat.chatDefaultPredefinedPromptsForkProject': 'How do I fork a project?',
  'WebAgenticDuoChat.chatDefaultTitle': 'GitLab Duo Agentic Chat',
  'WebAgenticDuoChat.chatDisclamer': 'Responses may be inaccurate. Verify before use.',
  'WebAgenticDuoChat.chatEmptyStateTitle':
    '👋 I am GitLab Duo Agentic Chat, your personal AI-powered assistant. How can I help you today?',
  'WebAgenticDuoChat.chatHistoryTitle': 'Chat history',
  'WebAgenticDuoChat.chatModelPlaceholder': 'GitLab Duo Agentic Chat',
  'WebAgenticDuoChat.chatPromptPlaceholderDefault': "Let's work through this together...",
  'WebAgenticDuoChat.chatPromptPlaceholderWithCommands': 'Type /help to learn more',
  'WebAgenticDuoChat.chatSubmitLabel': 'Send chat message.',
  'WebAgenticDuoChat.overLimitCharacterCountMessage': null,
  'WebAgenticDuoChat.remainingCharacterCountMessage': null,
  'WebDuoChat.chatBackToChatToolTip': 'Back to chat',
  'WebDuoChat.chatCancelLabel': 'Cancel',
  'WebDuoChat.chatDefaultPredefinedPromptsChangePassword': 'How do I change my password in GitLab?',
  'WebDuoChat.chatDefaultPredefinedPromptsCloneRepository': 'How do I clone a repository?',
  'WebDuoChat.chatDefaultPredefinedPromptsCreateTemplate': 'How do I create a template?',
  'WebDuoChat.chatDefaultPredefinedPromptsForkProject': 'How do I fork a project?',
  'WebDuoChat.chatDefaultTitle': 'GitLab Duo Chat',
  'WebDuoChat.chatDisclamer': 'Responses may be inaccurate. Verify before use.',
  'WebDuoChat.chatDropdownMoreOptions': 'More options',
  'WebDuoChat.chatEmptyStateTitle':
    '👋 I am GitLab Duo Chat, your personal AI-powered assistant. How can I help you today?',
  'WebDuoChat.chatHistoryTitle': 'Chat history',
  'WebDuoChat.chatModelPlaceholder': 'GitLab Duo Chat',
  'WebDuoChat.chatNewLabel': 'New chat',
  'WebDuoChat.chatNewToolTip': 'New chat',
  'WebDuoChat.chatPromptPlaceholderDefault': "Let's work through this together...",
  'WebDuoChat.chatPromptPlaceholderWithCommands': 'Type /help to learn more',
  'WebDuoChat.chatSubmitLabel': 'Send chat message.',
  'WebDuoChat.chatTitle': 'GitLab Duo Chat',
  'WebDuoChat.closeChatHeaderLabel': 'Close chat',
  'WebDuoChat.copySessionIdFailedToast': 'Could not copy session ID',
  'WebDuoChat.copySessionIdSuccessToast': 'Session ID copied to clipboard',
  'WebDuoChat.copySessionIdTooltip': 'Copy session ID: %{id}',
  'WebDuoChat.overLimitCharacterCountMessage': null,
  'WebDuoChat.remainingCharacterCountMessage': null,
};
